import { DirectionalDroppableType, Widget } from '@framework/engine';
import clx from 'classnames';
import React from 'react';
import { ContainerExtraDroppable } from './ContainerExtraDroppable';
import { WidgetPreviewRenderWrapper } from './WidgetPreviewRenderWrapper.styled';

export interface ILeafWidgetRenderProps {
  children?: React.ReactNode;
  compact?: boolean;
  widget: Widget;
  parent: Widget | undefined;
}

/**
 * Limita l'altezza massima di un widget
 */
export function SortableLeafWidgetRender(props: ILeafWidgetRenderProps) {
  const { children, compact, widget, parent } = props;

  return (
    <WidgetPreviewRenderWrapper className={clx({ compact })}>
      {children}
      <ContainerExtraDroppable
        widget={widget}
        parent={parent}
        type={DirectionalDroppableType.After}
      />
    </WidgetPreviewRenderWrapper>
  );
}
